import { ReactWebComponent } from '@app/utils/web-components'
import { lazy } from 'react'

const RootProviders = lazy(() => import('@app/components/AppProviders'))
const QuickStartChecklist = lazy(() => import('./components/QuickStartChecklist'))

class QuickStartChecklistWebComponent extends ReactWebComponent {
	override render() {
		return (
			<RootProviders>
				<QuickStartChecklist />
			</RootProviders>
		)
	}
}

customElements.define('quick-start-checklist', QuickStartChecklistWebComponent)
